<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4"> Delete Medication Class </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <p class="text-body-1">
            Are you sure you want to delete this medication class? This action
            cannot be undone.
          </p>
          <p v-if="subCategory" class="text-body-2 mt-2 font-weight-medium">
            Class: {{ subCategory.class_name }}
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose">
            Cancel
          </v-btn>
          <v-btn
            color="error"
            variant="flat"
            :disabled="loading"
            :loading="loading"
            @click="handleDelete"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_master_medication_class } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "DeleteSubCategoryDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    subCategory: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "deleted"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },
    async handleDelete() {
      this.loading = true;

      try {
        const response = await client.graphql({
          query: edit_master_medication_class,
          variables: {
            input: {
              class_id: this.subCategory?.class_id || "",
              class_status: "DEACTIVE",
            },
          },
        });

        const responseData = JSON.parse(
          response.data.edit_master_medication_class
        );

        if (responseData.status == "SUCCESS") {
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "Medication class deleted successfully",
            color: "success",
          };
          this.$emit("deleted", 0);
          this.handleClose();
        } else {
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "Failed to delete medication class",
            color: "error",
          };
        }
      } catch (error) {
        console.error("Error deleting medication class:", error);
        this.snackbar = {
          show: true,
          message: error.message || "Failed to delete medication class",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
